@if (market?.isBookmaker || market?.isMOddsBookmaker) {
  <app-bookmaker [market]="market" [openDate]="null" />
} @else if (market?.isFancy) {
  <app-fancy-market [market]="market" [openDate]="null" />
} @else if (market) {
  <app-market [data]="market" />
} @else {
  <app-alert
    [config]="{
      title: 'Market Not Found',
      subtitle: 'The requested market does not exist or is unavailable at the moment.',
      type: 'info',
    }" />
}
